import type { CreateLeadScoreCopyParams } from './interfaces';
import type {
  LeadScoreAction,
  LeadScoreContactability,
  LeadScoreSignal,
  LeadScoreTier,
  LeadScoreUseCase,
} from 'api/leadScore';

export interface BuildLeadScoreCopyRequestParams {
  configId: string;
  useCase: LeadScoreUseCase;
  address: string;
  score: number;
  maxScore: number;
  tier: LeadScoreTier;
  action: LeadScoreAction;
  signals: LeadScoreSignal[];
  contactability: LeadScoreContactability;
  contextId?: string;
}

export const buildLeadScoreCopyRequest = ({
  configId,
  useCase,
  address,
  score,
  maxScore,
  tier,
  action,
  signals,
  contactability,
  contextId,
}: BuildLeadScoreCopyRequestParams): CreateLeadScoreCopyParams => ({
  config_id: configId,
  use_case: useCase,
  address,
  score,
  max_score: maxScore,
  tier,
  action,
  signals: signals.map((signal) => ({
    id: signal.id,
    label: signal.label,
    category: signal.category,
    status: signal.status,
    detail: signal.detail,
    evidence: signal.evidence,
  })),
  contact: {
    is_do_not_call: contactability.isDoNotCall,
    is_active: contactability.isActive,
    has_email: contactability.hasEmail,
    has_phone_report: contactability.hasPhoneReport,
  },
  context_id: contextId,
});
